import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { useAuth } from "@clerk/tanstack-react-start";
import { Card } from "~/components/ui/card";
import { Loader } from "lucide-react";

export const Route = createFileRoute("/summit/register/complete")({
  component: SummitRegistrationComplete,
});

function SummitRegistrationComplete() {
  const { isSignedIn } = useAuth();
  const navigate = useNavigate();
  
  useEffect(() => {
    if (isSignedIn) {
      // User is authenticated, redirect back to the registration component
      // which will detect the URL params and complete the registration
      const urlParams = new URLSearchParams(window.location.search);
      const summitId = urlParams.get('summitId');
      const redirectUrl = urlParams.get('redirectUrl');
      
      const targetUrl = summitId ? 
        `/dashboard?summitId=${summitId}${redirectUrl ? `&redirectUrl=${encodeURIComponent(redirectUrl)}` : ''}` :
        '/dashboard';
        
      navigate({ to: targetUrl });
    }
  }, [isSignedIn, navigate]);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <Card className="w-full max-w-md p-8 text-center">
        <div className="text-brand-500 mb-4">
          <Loader className="w-12 h-12 mx-auto animate-spin" />
        </div>
        <h2 className="text-xl font-heading font-semibold mb-2">
          Completing Your Registration
        </h2>
        <p className="text-text-secondary">
          Please wait while we complete your summit registration...
        </p>
      </Card>
    </div>
  );
}